import _ from "underscore";

/**
 * Sort an array by multiple attributes, returned by a comparison function. Simlar to python's
 * sorted(array, key=comparisonFunction). comparisonFunction may return an array of attributes
 * which will be copmared in order, with the most important one first
 * @param array Array to sort
 * @param comparisonFunction Function that returns array used to compare entries
 *
 * Example:
 *  > let arr = [
 *      {
 *          inStock: 0,
 *          slug: 'bb',
 *      },
 *      {
 *          inStock: 1,
 *          slug: 'cc',
 *      },
 *      {
 *          inStock: 0,
 *          slug: 'aa',
 *      },
 *   ];
 * > sortByMultiple(arr, (item) => [item.inStock === 0 ? 0 : 1, item.slug])
 * [ { inStock: 0, slug: 'aa' },
 *   { inStock: 0, slug: 'bb' },
 *   { inStock: 1, slug: 'cc' } ]
 *
 */
export function sortByMultiple(array, comparisonFunction) {
    if (array.length === 0) {
        return array;
    }

    // to find the length of items returnd by comparisonFunction, call it on the first item
    const sampleKey = comparisonFunction(array[0]);
    const keyLength = sampleKey.length;

    // We use a decorate-sort-undecorate pattern, where we first map each item in the original
    // array into an array the item itself, followed by the output of the comparisonFunction. We
    // then sort this new "decorated" array by the entries in the comparison array, and finally
    // extract the original items.
    //
    // To sort by multiple values in turn, we make use of _.sortBy which is stable (items that
    // compare as equal keep their original order) and sort by each entry in the comparison array
    // in turn, starting with the least important. That way, ties in more important sorters will
    // keep the order provided by the less important sorters

    let decorated = array.map((item) => [item].concat(comparisonFunction(item)));
    for (let index = keyLength; index > 0; index--) {
        decorated = _.sortBy(decorated, (item) => item[index]);
    }
    const sorted = decorated.map((item) => item[0]);
    return sorted;
}
